<template>
    <nav class="w-full"
         aria-label="Breadcrumb">
        <transition-group tag="ul"
                          name="list-fade"
                          class="w-full overflow-y-hidden overflow-x-hidden h-23 whitespace-nowrap relative">
            <li v-for="(crumb, index) in breadcrumbs"
                :key="crumb.url"
                class="-no-wrap inline-block">
                <template v-if="index < breadcrumbs.length - 1">
                    <CultureAwareRouterLink :to="crumb.page ? { name: crumb.page } : crumb.url"
                                            class="font-medium text-11 text-gray-900 underline hover:text-gray-800 leading-large py-10">
                        <span>{{ crumb.name }}</span>
                    </CultureAwareRouterLink>
                    <CIcon
                        class="mx-6"
                        name="arrow-right"
                        width="6"
                        height="6"/>
                </template>
                <span v-else
                      class="text-11 text-gray-900 leading-large py-10">
                    <span aria-current="page">{{ crumb.name }}</span>
                </span>
            </li>
        </transition-group>
    </nav>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import appStore from '@/core/app/app.store';
import { BreadcrumbItem } from '@/types/contentServerContract';

const breadcrumbs = computed((): BreadcrumbItem[] => {
    return [...appStore.breadcrumbPrettified];
});
</script>

<style lang="less" scoped>
.list-fade-enter-active,
.list-fade-leave-active {
    transition: opacity 0.2s ease;
}

.list-fade-enter-from,
.list-fade-leave-to {
    opacity: 0;
}

.list-fade-leave-active {
    position: absolute;
}

.list-fade-move {
    transition: transform 0.2s ease;
}

.-no-wrap {
    white-space: nowrap;
}
</style>
